<template>
    <div>
        <div v-if="loading" class="loading-overlay">

            <div class="loading-card">

                <div class="loading-spinner"></div>

                <div class="loading-message">
                    {{ loadingMessage || 'Consultando Ticket...' }}
                </div>

            </div>

        </div>

        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <div class="input-group date" id="datetimepicker1">
                        <input type="number" class="form-control" placeholder="N° Ticket a Ingresar..."
                            v-model="nro_ticket" v-on:keyup.enter="consultar_ticket">
                        <span class="input-group-addon input-group-append">
                            <button class="btn btn-primary btn-sm" type="button" @click="consultar_ticket()"> <span
                                    class="fas fa-search"></span></button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <div class="input-group date" id="datetimepicker1">
                        <input type="text" class="form-control" placeholder="Consultar Ingreso Patente en Portería..."
                            v-model="patente_camion" v-on:keyup.enter="consultar_patente">
                        <span class="input-group-addon input-group-append">
                            <button class="btn btn-primary btn-sm" type="button" @click="consultar_patente()"> <span
                                    class="fas fa-search"></span></button>
                        </span>
                    </div>
                </div>

            </div>
        </div>



        <!-- ALERT-->
        <div v-if="alert" class="dialog-overlay">

            <div class="dialog-box">

                <!-- HEADER -->
                <div class="dialog-header">
                    <div class="dialog-title">
                        <i :class="alert_icono"></i>
                        <span>{{ alert_mensaje }}</span>
                    </div>

                    <button class="dialog-close" @click="alert = false">
                        &times;
                    </button>
                </div>

                <!-- BODY -->
                <div class="dialog-body">

                    <!-- PERMISOS -->
                    <div v-if="alert_permisos && alert_permisos.length">
                        <h6 class="dialog-subtitle">Error de Permisos</h6>
                        <ul class="dialog-list">
                            <li v-for="(m, index) in alert_permisos" :key="'p' + index">
                                {{ m }}
                            </li>
                        </ul>
                    </div>

                    <!-- ERRORES -->
                    <div v-if="alert_errores && alert_errores.length">
                        <h6 class="dialog-subtitle text-danger">Errores de Validación</h6>
                        <ul class="dialog-list error">
                            <li v-for="(m, index) in alert_errores" :key="'e' + index">
                                {{ m }}
                            </li>
                        </ul>
                    </div>

                </div>

                <!-- FOOTER -->
                <div class="dialog-footer">
                    <button class="btn btn-primary btn-sm" @click="alert = false">
                        Entendido
                    </button>
                </div>

            </div>

        </div>
        <!-- ALERT-->





        <div class="viaje-row mb-2" v-if="viaje_camion">

            <div class="cell id">
                <span>ID</span>
                <strong>{{ viaje_camion.id }}</strong>
            </div>

            <div class="cell">
                <span>N° Viaje</span>
                <strong>{{ viaje_camion.ingreso_vehiculos_porteria_id }}</strong>
            </div>

            <div class="cell">
                <span>Fecha Ingreso Portería</span>
                <strong>{{ viaje_camion.fecha_ingreso | fecha_hora }}</strong>
            </div>

            <div class="cell patente">
                <span>Patente</span>
                <strong>{{ viaje_camion.patente }}</strong>
            </div>

            <div class="cell">
                <span>Guías</span>
                <strong class="highlight">{{ viaje_camion.cantidad_guias }}</strong>
            </div>

            <div class="cell guias">
                <span>N° Guías</span>
                <strong>{{ viaje_camion.guias }}</strong>
            </div>

        </div>





        <div class="card card-frame col-md-12">
            <div class="card-body">

                <div class="row mb-2">
                    <div class="col">
                        <strong>TICKET {{ isEtruck ? 'ETRUCK' : 'PESAMATIC' }}</strong>
                    </div>
                    <div class="col-auto" v-if="verificar_permiso('romanaCambiarSistemaPesaje')">
                        <div class="pesaje-switch text-center">
                            <div class="label">Sistema de Pesaje</div>

                            <label class="switch my-1">
                                <input type="checkbox" v-model="isEtruck">
                                <span class="slider"></span>
                            </label>

                            <div class="value">
                                {{ isEtruck ? 'Etruck' : 'Pesamatic' }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-blue">
                                <tr>
                                    <th class="text-center">PATENTE</th>
                                    <th class="text-center">N° TICKET</th>
                                    <th class="text-center">CICLO</th>
                                    <th class="text-center">CHOFER</th>
                                    <!-- <th>EMPRESA</th> -->
                                </tr>
                            </thead>
                            <tr>
                                <td class="text-center">{{ pesaje ? pesaje.patente : '' }}</td>
                                <td class="text-center">{{ pesaje ? pesaje.numero : '' }}
                                </td>
                                <td class="text-center">{{ pesaje ? pesaje.ciclo : '' }}</td>
                                <td class="text-center">{{ nombre_conductor }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2"><b>INFORMACIÓN PESO BRUTO</b></th>
                                </tr>
                                <tr>
                                    <th>FECHA PESO BRUTO</th>
                                    <td>{{ pesaje ? pesaje.fechaBruto : null | fecha_hora }}
                                    </td>

                                </tr>
                                <tr>
                                    <th>PESO TOTAL BRUTO</th>
                                    <td>{{ pesaje ? pesaje.pesoBruto : '' }}</td>
                                </tr>
                                <tr>
                                    <th>PESO BRUTO SIN/ENV</th>
                                    <td>{{ pesaje ? pesaje.pesoBrutoSinEnvase : '' }} <span class="badge badge-warning"
                                            v-if="calcularMultiplo10(pesaje.pesoBrutoSinEnvase)"><i
                                                class="fas fa-exclamation-circle"></i></span></td>
                                </tr>
                            </thead>
                        </table>
                    </div>

                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2"><b>INFORMACIÓN PESO TARA</b></th>
                                </tr>
                                <tr>
                                    <th>FECHA TARA</th>
                                    <td>{{ pesaje ? pesaje.fechaTara : null | fecha_hora }}
                                    </td>

                                </tr>
                                <tr>
                                    <th>PESO TOTAL TARA</th>
                                    <td>{{ pesaje ? pesaje.pesoTara : '' }}</td>

                                </tr>
                                <tr>
                                    <th>PESO TARA SIN/ENV</th>
                                    <td>{{ pesaje ? pesaje.pesoTaraSinEnvase : '' }} <span class="badge badge-warning"
                                            v-if="calcularMultiplo10(pesaje.pesoTaraSinEnvase)"><i
                                                class="fas fa-exclamation-circle"></i></span></td>
                                </tr>
                            </thead>
                        </table>
                    </div>



                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2"><b>INFORMACIÓN PESO NETO</b></th>
                                </tr>
                                <tr>
                                    <th>PESO NETO INFORMADO</th>
                                    <td>{{ peso_informado_total }}</td>

                                </tr>
                                <tr>
                                    <th>PESO NETO</th>
                                    <td>{{ pesaje ? pesaje.pesoNeto : '' }}</td>

                                </tr>
                                <tr>
                                    <th>PESO NETO CORREGIDO</th>
                                    <td>{{ pesaje ? pesaje.pesoNetoCorregido : '' }} <span class="badge badge-warning"
                                            v-if="calcularMultiplo10(pesaje.pesoNetoCorregido)"><i
                                                class="fas fa-exclamation-circle"></i></span></td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-tea">
                                <tr>
                                    <th class="text-center">N° GUÍA</th>
                                    <th class="text-center">PROVEEDOR</th>
                                    <th class="text-center">SUCURSAL</th>
                                    <th class="text-center">PESO INFORMADO</th>
                                    <th class="text-center">PESO RECIBIDO</th>
                                    <th class="text-center">CANTIDAD BINS</th>
                                    <th class="text-center">N° GUÍAS REEMPLAZADAS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(guia, index) in documentos" :key="index">
                                    <td class="text-center">{{ guia.numero }}</td>
                                    <td class="text-center">{{ guia.proveedor }}</td>
                                    <td class="text-center">{{ guia.sucursal }}</td>
                                    <td class="text-center">{{ guia.pesoInformado }}</td>
                                    <td class="text-center">{{ guia.pesoRecibido }}</td>
                                    <td class="text-center">{{ guia.cantidadEnvases }}</td>
                                    <td class="text-center">{{ guia.guiasReemplazadas }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div :class="`alert alert-${alert_2_clase} fade show`" role="alert" v-if="alert_2">
            <span class="alert-icon"><i class="ni ni-check-bold"></i></span>
            <span class="alert-text"><strong>{{alert_2_mensaje}}</strong></span>
            <button type="button" class="close" aria-label="Close" @click="cerrar_alert_2">
                <span aria-hidden="true">&times;</span>
            </button>
            <ul>
                <li v-for="(e,idx) in errores" :key="idx">{{e}}</li>
            </ul>
        </div> -->

        <!-- <div class="row">
            <div class="col">
                <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="alert">
                    <span class="alert-icon"><i class="fas fa-exclamation-triangle"></i></span>
                    <span class="alert-text"><strong>Error de Validación!</strong></span>
                    <span class="alert-text" v-for="(m,index) in mensaje" :key="index"> <strong>{{`${m},`}}</strong></span>
                    
                    <button type="button" class="close" @click="alert = !alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div> -->




        <div class="card card-frame col-md-12" v-show="mostrar_ticket_romana">
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col">
                        <strong>TICKET ROMANA</strong>
                    </div>
                    <div class="col text-right">
                        <button class="btn btn-1 btn-lg" :disabled="ticket_romana == null || isEmpty(pesaje)"
                            @click="guardarTicket">
                            <i class="fas fa-save"></i>
                            GUARDAR TICKET </button>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-blue">
                                <tr>
                                    <th class="text-center">PATENTE</th>
                                    <th class="text-center">N° TICKET</th>
                                    <th class="text-center">CICLO</th>
                                    <th class="text-center">CHOFER</th>
                                    <th class="text-center">SELECCIONE MATERIA PRIMA</th>
                                </tr>
                            </thead>
                            <tr>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.patente : '' }}</td>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.codigo_ticket : '' }}</td>
                                <td class="text-center">{{ ticket_romana ? ticket_romana.ciclo_ticket ==
                                    2 ? 'Despacho' : 'Recepción' : '' }}</td>
                                <td class="text-center">{{ nombre_conductor }}</td>
                                <td class="text-center">
                                    <select class="form-control form-control-sm full-width"
                                        v-model="ticket_romana.mp_tipos_id" @change="actualizarMateriaPrima">
                                        <option value="">-- Seleccionar --</option>
                                        <option v-for="(opc, index) in mp_tipos" :key="index" :value="opc.id">{{
                                            opc.nombre }}
                                        </option>
                                    </select>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">

                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO BRUTO</th>
                                </tr>
                                <tr>
                                    <th>FECHA PESO BRUTO</th>
                                    <!--<td>
                                        {{ ticket_romana ? ticket_romana.fecha_hora_bruto : null | fecha_hora }}
                                        <div
                                            v-if="ticket_romana.datos_modificados && ticket_romana.datos_modificados.fecha_hora_bruto">
                                            <i class="fas fa-exclamation-circle"></i>
                                            <small>La fecha peso bruto se actualizará a {{
                                                ticket_romana.datos_modificados.fecha_hora_bruto | fecha_hora }} cuando
                                                se guarde el ticket</small>
                                        </div>
                                    </td>-->
                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.fecha_hora_bruto : null | fecha_hora }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.fecha_hora_bruto
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.fecha_hora_bruto }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.fecha_hora_bruto
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>

                                </tr>
                                <tr>
                                    <th>PESO TOTAL BRUTO</th>

                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.peso_total_bruto : '' }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.peso_total_bruto
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.peso_total_bruto }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.peso_total_bruto
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>
                                </tr>
                                <tr>
                                    <th>PESO BRUTO SIN/ENV</th>
                                    <!--<td>
                                        {{ ticket_romana ? ticket_romana.peso_vehiculo_bruto : '' }}
                                        <div
                                            v-if="ticket_romana.datos_modificados && ticket_romana.datos_modificados.peso_vehiculo_bruto">
                                            <i class="fas fa-exclamation-circle"></i>
                                            <small>El peso bruto sin/env se actualizará a {{
                                                ticket_romana.datos_modificados.peso_vehiculo_bruto }} cuando se guarde
                                                el ticket</small>
                                        </div>
                                    </td>-->

                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.peso_vehiculo_bruto : '' }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.peso_vehiculo_bruto
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.peso_vehiculo_bruto }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.peso_vehiculo_bruto
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>
                                </tr>
                            </thead>
                        </table>
                    </div>

                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO TARA</th>
                                </tr>
                                <tr>
                                    <th>FECHA TARA</th>
                                    <!--<td>
                                        {{ ticket_romana ? ticket_romana.fecha_hora_tara : null | fecha_hora }}
                                        <div
                                            v-if="ticket_romana.datos_modificados && ticket_romana.datos_modificados.fecha_hora_tara">
                                            <i class="fas fa-exclamation-circle"></i>
                                            <small>La fecha de tara se actualizará a {{
                                                ticket_romana.datos_modificados.fecha_hora_tara | fecha_hora }} cuando
                                                se guarde el
                                                ticket</small>
                                        </div>
                                    </td>-->
                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.fecha_hora_tara : null | fecha_hora }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.fecha_hora_tara
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.fecha_hora_tara }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.fecha_hora_tara
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>
                                </tr>
                                <tr>
                                    <th>PESO TOTAL TARA</th>
                                    <!--<td>
                                        {{ ticket_romana ? ticket_romana.peso_total_tara : '' }}
                                        <div
                                            v-if="ticket_romana.datos_modificados && ticket_romana.datos_modificados.peso_total_tara">
                                            <i class="fas fa-exclamation-circle"></i>
                                            <small>El peso total tara se actualizará a {{
                                                ticket_romana.datos_modificados.peso_total_tara }} cuando se guarde el
                                                ticket</small>
                                        </div>
                                    </td>-->
                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.peso_total_tara : '' }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.peso_total_tara
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.peso_total_tara }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.peso_total_tara
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>
                                </tr>
                                <tr>
                                    <th>PESO TARA SIN/ENV</th>
                                    <!--<td>
                                        {{ ticket_romana ? ticket_romana.peso_vehiculo_tara : '' }}
                                        <div
                                            v-if="ticket_romana.datos_modificados && ticket_romana.datos_modificados.peso_vehiculo_tara">
                                            <i class="fas fa-exclamation-circle"></i>
                                            <small>El peso tara sin/env se actualizará a {{
                                                ticket_romana.datos_modificados.peso_vehiculo_tara }} cuando se guarde
                                                el ticket</small>
                                        </div>
                                    </td>-->
                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.peso_vehiculo_tara : '' }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.peso_vehiculo_tara
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.peso_vehiculo_tara }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.peso_vehiculo_tara
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>
                                </tr>
                            </thead>
                        </table>
                    </div>



                    <div class="col-md-4 table-responsive">
                        <table class="table align-items-center border">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center" colspan="2">INFORMACIÓN PESO NETO</th>
                                </tr>
                                <tr>
                                    <th>PESO NETO INFORMADO</th>
                                    <!--<td>
                                        {{ ticket_romana ? ticket_romana.peso_informado : '' }}
                                        <div
                                            v-if="ticket_romana.datos_modificados && ticket_romana.datos_modificados.peso_informado">
                                            <i class="fas fa-exclamation-circle"></i>
                                            <small>El peso neto informado se actualizará a {{
                                                ticket_romana.datos_modificados.peso_informado }} cuando se guarde el
                                                ticket</small>
                                        </div>
                                    </td>-->
                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.peso_informado : '' }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.peso_informado
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.peso_informado }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.peso_informado
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>

                                </tr>
                                <tr>
                                    <th>PESO NETO</th>
                                    <!-- <td>{{peso_neto_corregido_romana}}</td> -->
                                    <!--<td>
                                        {{ ticket_romana ? ticket_romana.peso_comercial_neto : '' }}
                                        <div
                                            v-if="ticket_romana.datos_modificados && ticket_romana.datos_modificados.peso_comercial_neto">
                                            <i class="fas fa-exclamation-circle"></i>
                                            <small>El peso neto se actualizará a {{
                                                ticket_romana.datos_modificados.peso_comercial_neto }} cuando se guarde
                                                el ticket</small>
                                        </div>
                                    </td>-->
                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.peso_comercial_neto : '' }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.peso_comercial_neto
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.peso_comercial_neto }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.peso_comercial_neto
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>
                                </tr>
                                <tr>
                                    <th>PESO NETO CORREGIDO</th>
                                    <!-- <td>{{peso_neto_corregido_romana}}</td> -->
                                    <!--<td>
                                        {{ ticket_romana ? ticket_romana.peso_comercial_neto_corregido : '' }}
                                        <div
                                            v-if="ticket_romana.datos_modificados && ticket_romana.datos_modificados.peso_comercial_neto_corregido">
                                            <i class="fas fa-exclamation-circle"></i>
                                            <small>El peso neto corregido se actualizará a {{
                                                ticket_romana.datos_modificados.peso_comercial_neto_corregido }} cuando
                                                se guarde el ticket</small>
                                        </div>
                                    </td>-->
                                    <td>
                                        <div class="peso-wrapper">
                                            <span>
                                                {{ ticket_romana ? ticket_romana.peso_comercial_neto_corregido : '' }}
                                            </span>

                                            <template v-if="
                                                ticket_romana &&
                                                ticket_romana.datos_modificados &&
                                                ticket_romana.datos_modificados.peso_comercial_neto_corregido
                                            ">
                                                <i class="fas fa-arrow-right arrow"></i>

                                                <span class="nuevo">
                                                    {{ ticket_romana.datos_modificados.peso_comercial_neto_corregido }}
                                                </span>

                                                <i class="fas fa-exclamation-circle warning"></i>
                                            </template>
                                        </div>

                                        <small v-if="
                                            ticket_romana &&
                                            ticket_romana.datos_modificados &&
                                            ticket_romana.datos_modificados.peso_comercial_neto_corregido
                                        " class="texto-ayuda">
                                            Se actualizará cuando se guarde el ticket
                                        </small>
                                    </td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>




                <div class="row mb-2 mt-4" v-if="folio_transbordador != null">

                    <div class="col-md-12 mb-1">
                        <strong>INFORMACIÓN TRANSBORDADOR</strong>
                    </div>

                    <!-- IDA -->
                    <div class="col-md-12">
                        <div class="trans-row">

                            <div class="trans-title thead-orange">
                                IDA
                            </div>

                            <div class="trans-field">
                                <label>Folio</label>
                                <input type="number" class="input-mini form-control"
                                    v-model="folio_transbordador.folio_1">
                            </div>

                            <div class="trans-field">
                                <label>Tipo</label>
                                <select class="input-mini form-control form-control-sm"
                                    v-model="folio_transbordador.tipo_carrocerias_id_1">
                                    <option value="">...</option>
                                    <option v-for="tipo in tipo_carrocerias" :key="tipo.id" :value="tipo.id">
                                        {{ tipo.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="trans-field">
                                <label>Naviera</label>
                                <select class="input-mini form-control form-control-sm"
                                    v-model="folio_transbordador.folio_1_empresas_id">
                                    <option value="">...</option>
                                    <option v-for="trans in empresas_transbordador" :key="trans.id" :value="trans.id">
                                        {{ trans.nombre }}
                                    </option>
                                </select>
                            </div>

                        </div>
                    </div>

                    <!-- VUELTA -->
                    <div class="col-md-12 mt-1">
                        <div class="trans-row">

                            <div class="trans-title thead-orange">
                                VUELTA
                            </div>

                            <div class="trans-field">
                                <label>Folio</label>
                                <input type="number" class="input-mini form-control"
                                    v-model="folio_transbordador.folio_2">
                            </div>

                            <div class="trans-field">
                                <label>Tipo</label>
                                <select class="input-mini form-control form-control-sm"
                                    v-model="folio_transbordador.tipo_carrocerias_id_2">
                                    <option value="">...</option>
                                    <option v-for="tipo in tipo_carrocerias" :key="tipo.id" :value="tipo.id">
                                        {{ tipo.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="trans-field">
                                <label>Naviera</label>
                                <select class="input-mini form-control form-control-sm"
                                    v-model="folio_transbordador.folio_2_empresas_id">
                                    <option value="">...</option>
                                    <option v-for="trans in empresas_transbordador" :key="trans.id" :value="trans.id">
                                        {{ trans.nombre }}
                                    </option>
                                </select>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="row mt-2 mb-2" v-if="guias_romana.length > 1">
                    <div class="col-md-6">
                        <ToogleSwitch v-model="multiple_pcc" label="Agrupar PCC" v-if="ticket_romana.id" />
                    </div>
                    <div class="col-md-6 text-right">
                        <button type="button" class="btn btn-primary btn-md"
                            v-if="guias_romana.length > 0 && multiple_pcc" @click="abrirModalPCC">
                            Formulario PCC
                        </button>
                    </div>
                </div>

                <div class="row mt-5" v-for="(g, idx_guia) in guias_romana" :key="idx_guia">


                    <!--Seccion Guía-->
                    <div class="col-md-12">
                        <div class="card guia-card mb-3">

                            <!-- HEADER -->
                            <div class="card-header d-flex justify-content-between align-items-center"
                                style="background: linear-gradient(90deg, #0d1f45, #1e3a8a);">
                                <div class="col-md-6">

                                    <div>
                                        <h2 class="text-white">GUÍA N°{{ g.numero_guia }}
                                            <span v-if="g.datos_modificados && g.datos_modificados.numero_guia">
                                                <div class="custom-tooltip">
                                                    <small class="custom-tooltiptext">El número de guía se
                                                        actualizará a {{
                                                            g.datos_modificados.numero_guia }} cuando se guarde el
                                                        ticket</small>
                                                    <i class="fas fa-exclamation-circle"></i>
                                                </div>
                                            </span>

                                            <button v-if="g.historicas && g.historicas.length > 0" type="button"
                                                class="btn btn-primary btn-sm" data-toggle="modal"
                                                :data-target="`#modal_g_historicas${g.numero_guia}_${g.documento_id_Etruck}`">
                                                Guías reemplazadas
                                            </button>
                                        </h2>
                                        <span class="text-white" v-if="g.tiene_datos_modificados">El símbolo "<i
                                                class="fas fa-exclamation-circle"></i>"
                                            indica que
                                            dato fue modificado en sistema Pesamatic</span>
                                    </div>


                                </div>
                                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal"
                                    :data-target="`#modal_pcc`" v-if="guias_romana.length > 0 && !multiple_pcc"
                                    @click="abrirModalPCC(g, idx_guia)">
                                    Formulario PCC
                                </button>
                            </div>

                            <!-- BODY -->
                            <div class="card-body">

                                <!-- ===================== -->
                                <!-- DATOS GENERALES -->
                                <!-- ===================== -->
                                <h6 class="section-title">Datos Generales</h6>

                                <div class="row">

                                    <div class="col-md-3 form-item">
                                        <label>N° Guía Origen</label>
                                        <input type="number" class="form-control form-control-sm"
                                            v-model="g.numero_guia_origen">
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Fecha</label>
                                        <input type="datetime-local" class="form-control form-control-sm"
                                            v-model="g.fecha">
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Empresa</label>
                                        <select class="form-control form-control-sm" v-model="g.empresas_id" disabled>
                                            <option value="">-- Seleccionar --</option>
                                            <option v-for="(opc, index) in empresas" :key="index" :value="opc.id">
                                                {{ opc.nombre }}
                                            </option>
                                        </select>

                                        <small v-if="g.datos_modificados && g.datos_modificados.empresas_id"
                                            class="text-warning">
                                            <i class="fas fa-exclamation-circle"></i>
                                            Se actualizará al guardar
                                        </small>
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Sucursal</label>
                                        <select class="form-control form-control-sm" v-model="g.dependencias_id"
                                            disabled>
                                            <option value="">-- Seleccionar --</option>
                                            <option v-for="(opc, index) in dependencias" :key="index" :value="opc.id">
                                                {{ opc.nombre }}
                                            </option>
                                        </select>

                                        <small v-if="g.datos_modificados && g.datos_modificados.dependencias_id"
                                            class="text-warning">
                                            <i class="fas fa-exclamation-circle"></i>
                                            Se actualizará al guardar
                                        </small>
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Materia Prima</label>
                                        <select class="form-control form-control-sm" v-model="g.mp_tipos_id"
                                            @change="actualizarDatoscomplementarios(idx_guia)" disabled>
                                            <option value="">-- Seleccionar --</option>
                                            <option v-for="(opc, index) in mp_tipos" :key="index" :value="opc.id">
                                                {{ opc.nombre }}
                                            </option>
                                        </select>

                                        <small v-if="g.datos_modificados && g.datos_modificados.mp_tipos_id"
                                            class="text-warning">
                                            <i class="fas fa-exclamation-circle"></i>
                                            Se actualizará al guardar
                                        </small>
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Peso Informado</label>
                                        <input type="number" class="form-control form-control-sm"
                                            v-model="g.peso_informado" disabled>

                                        <small v-if="g.datos_modificados && g.datos_modificados.peso_informado"
                                            class="text-warning">
                                            <i class="fas fa-exclamation-circle"></i>
                                            Se actualizará al guardar
                                        </small>
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Peso Recibido</label>
                                        <input type="number" class="form-control form-control-sm" v-model="g.peso_real">

                                        <small v-if="g.datos_modificados && g.datos_modificados.peso_real"
                                            class="text-warning">
                                            <i class="fas fa-exclamation-circle"></i>
                                            Recalculado automáticamente
                                        </small>
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Cantidad Bins</label>
                                        <input type="number" class="form-control form-control-sm"
                                            v-model="g.cantidad_bins" disabled>

                                        <small v-if="g.datos_modificados && g.datos_modificados.cantidad_bins"
                                            class="text-warning">
                                            <i class="fas fa-exclamation-circle"></i>
                                            Actualizado automáticamente
                                        </small>
                                    </div>

                                </div>

                                <div class="row">



                                    <div class="col-md-3 form-item">
                                        <label>Muelle</label>
                                        <select class="form-control form-control-sm" v-model="g.muelles_id">
                                            <option v-for="(opc, index) in muelles" :key="index" :value="opc.id">
                                                {{ opc.nombre }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-3 form-item">
                                        <label>Barco</label>
                                        <select class="form-control form-control-sm" v-model="g.barcos_id">
                                            <option v-for="(opc, index) in barcos" :key="index" :value="opc.id">
                                                {{ opc.nombre }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-md-6 form-item">
                                        <label>Restricciones</label>
                                        <v-select multiple :reduce="option => option.id" v-model="g.restricciones_ids"
                                            :options="restricciones" label="nombre">
                                        </v-select>
                                    </div>

                                </div>

                                <!-- ===================== -->
                                <!-- ARCHIVOS -->
                                <!-- ===================== -->
                                <h6 class="section-title mt-3">Archivos</h6>

                                <div class="row">
                                    <div class="col-md-6 form-item">
                                        <label>Guía</label>

                                        <div class="upload-box">

                                            <!-- ACCIONES -->
                                            <div class="upload-actions">

                                                <button v-show="g.url_guia != null && g.url_guia != ''"
                                                    class="btn btn-outline-danger btn-sm" @click="abrirPdf(g.url_guia)">
                                                    <i class="fas fa-file-pdf"></i>
                                                    Ver PDF
                                                </button>

                                            </div>

                                            <!-- INPUT -->
                                            <label class="upload-input">

                                                <i class="fas fa-upload"></i>
                                                <span>Seleccionar archivo</span>

                                                <input type="file" :ref="`file${g.numero_guia}`"
                                                    @change="subirGuia($event, g.numero_guia, idx_guia)">
                                            </label>

                                            <!-- INFO -->
                                            <small class="upload-hint">
                                                Puede reemplazar la guía subiendo un nuevo archivo
                                            </small>

                                        </div>
                                    </div>

                                    <div class="col-md-6 form-item">
                                        <label>Guía Origen</label>

                                        <div class="upload-box">

                                            <!-- PREVIEW -->
                                            <div class="upload-actions">

                                                <button v-show="g.url_guia_origen != null && g.url_guia_origen != ''"
                                                    class="btn btn-outline-danger btn-sm"
                                                    @click="abrirPdf(g.url_guia_origen, 'guias/guias_origen')">
                                                    <i class="fas fa-file-pdf"></i>
                                                    Ver PDF
                                                </button>

                                            </div>

                                            <!-- INPUT -->
                                            <label class="upload-input">

                                                <i class="fas fa-upload"></i>
                                                <span>Seleccionar archivo</span>

                                                <input type="file" :ref="`file_origen_${g.numero_guia}`"
                                                    @change="subirGuiaOrigen($event, g.numero_guia, idx_guia)">
                                            </label>

                                        </div>
                                    </div>

                                    <!-- ALERT -->
                                    <div class="col-md-12 mt-2" v-if="g.alert">
                                        <div
                                            :class="`alert alert-sm alert-${g.alert_clase} d-flex justify-content-between align-items-center`">

                                            <div>
                                                <i :class="g.alert_icono"></i>
                                                {{ g.alert_mensaje }}
                                            </div>

                                            <button type="button" class="close" @click="g.alert = false"
                                                style="font-size: 16px;">
                                                &times;
                                            </button>

                                        </div>
                                    </div>

                                </div>

                                <!-- ===================== -->
                                <!-- DISTRIBUCIONES -->
                                <!-- ===================== -->
                                <h3 class="section-title mt-3">Distribución Materia Prima</h3>

                                <div class="card border">

                                    <!-- HEADER -->
                                    <div class="card-header d-flex justify-content-between align-items-center">


                                        <button class="btn btn-success btn-sm" @click="agregarDistribucion(idx_guia)">
                                            <i class="fas fa-plus"></i> Agregar
                                        </button>
                                    </div>

                                    <!-- BODY -->
                                    <div class="card-body p-2">

                                        <!-- LISTADO -->
                                        <div v-for="(distribucion, idx) in g.distribuciones" :key="idx"
                                            class="distribucion-row">

                                            <div class="row align-items-center">

                                                <!-- DESTINO -->
                                                <div class="col-md-2 form-item">
                                                    <label>Destino</label>
                                                    <select class="form-control form-control-sm"
                                                        v-model="distribucion.distribucion_destinos_id">
                                                        <option v-for="(opc, i) in guia_distribucion_destinos" :key="i"
                                                            :value="opc.id">
                                                            {{ opc.nombre }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <!-- PRODUCTO -->
                                                <div class="col-md-2 form-item">
                                                    <label>Producto</label>
                                                    <select class="form-control form-control-sm"
                                                        v-model="distribucion.productos_recibidos_id">
                                                        <option v-for="(opc, i) in productos_recibidos" :key="i"
                                                            :value="opc.id">
                                                            {{ opc.nombre }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <!-- MP -->
                                                <div class="col-md-2 form-item">
                                                    <label>Materia Prima</label>
                                                    <select class="form-control form-control-sm"
                                                        v-model="distribucion.mp_tipos_id" disabled>
                                                        <option v-for="(opc, i) in materias_primas" :key="i"
                                                            :value="opc.id">
                                                            {{ opc.nombre }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <!-- ESPECIE -->
                                                <div class="col-md-2 form-item">
                                                    <label>Especie</label>
                                                    <select class="form-control form-control-sm"
                                                        v-model="distribucion.especies_id">
                                                        <option v-for="(opc, i) in especies(distribucion.mp_tipos_id)"
                                                            :key="i" :value="opc.id">
                                                            {{ opc.nombre }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <!-- BINS -->
                                                <div class="col-md-1 form-item">
                                                    <label>Bins</label>
                                                    <input type="number" class="form-control form-control-sm"
                                                        v-model="distribucion.cantidad_bins">
                                                </div>

                                                <!-- KG -->
                                                <div class="col-md-2 form-item">
                                                    <label>Kg</label>
                                                    <input type="number" class="form-control form-control-sm"
                                                        v-model="distribucion.peso_real">

                                                    <small v-if="distribucion.peso_modificado" class="text-warning">
                                                        <i class="fas fa-exclamation-circle"></i>
                                                    </small>
                                                </div>

                                                <!-- DELETE -->
                                                <div class="col-md-1 text-center mt-3">
                                                    <button class="btn btn-danger btn-sm" style="border-radius: 100%;"
                                                        @click="quitarDistribucion(distribucion, idx, idx_guia)">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <!-- VACÍO -->
                                        <div v-if="g.distribuciones.length === 0" class="text-center text-muted py-3">
                                            No hay distribuciones
                                        </div>

                                    </div>
                                </div>
                                <!-- ===================== -->
                                <!-- DISTRIBUCIONES -->
                                <!-- ===================== -->


                                <!-- ===================== -->
                                <!-- CENTROS Y JAULAS -->
                                <!-- ===================== -->
                                <h3 class="section-title mt-3">Información de Centros y Jaulas</h3>

                                <div class="card border">

                                    <!-- HEADER -->
                                    <div class="card-header d-flex justify-content-between align-items-center">

                                        <button class="btn btn-success btn-sm" @click="agregarCentroJaula(idx_guia)">
                                            <i class="fas fa-plus"></i> Agregar
                                        </button>
                                    </div>

                                    <!-- BODY -->
                                    <div class="card-body p-2">

                                        <!-- FILAS -->
                                        <div v-for="(cen, idx_centro_jaula) in g.guia_centro_jaulas"
                                            :key="idx_centro_jaula" class="centro-row">

                                            <div class="row align-items-center">

                                                <!-- CODIGO -->
                                                <div class="col-md-5 form-item">
                                                    <label>Código SIEP Centro</label>
                                                    <input type="text" class="form-control form-control-sm"
                                                        v-model="cen.codigo_siep">
                                                </div>

                                                <!-- JAULAS -->
                                                <div class="col-md-5 form-item">
                                                    <label>N° Jaulas</label>
                                                    <input type="text" class="form-control form-control-sm"
                                                        v-model="cen.nro_jaulas" placeholder="Ej: 1,2,3">
                                                </div>

                                                <!-- ELIMINAR -->
                                                <div class="col-md-2 text-center mt-3">
                                                    <button class="btn btn-danger btn-sm" style="border-radius: 100%;"
                                                        @click="quitarCentroJaula(cen, idx_guia, idx_centro_jaula)">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </div>

                                            </div>

                                        </div>

                                        <!-- VACÍO -->
                                        <div v-if="g.guia_centro_jaulas.length === 0"
                                            class="text-center text-muted py-3">
                                            No hay centros/jaulas agregados
                                        </div>

                                    </div>
                                </div>

                                <!-- ===================== -->
                                <!-- CENTROS Y JAULAS -->
                                <!-- ===================== -->

                                <!-- ===================== -->
                                <!-- DATOS COMPLEMENTARIOS -->
                                <!-- ===================== -->
                                <h3 class="section-title mt-3">Datos Complementarios</h3>

                                <div class="card border">

                                    <!-- HEADER -->
                                    <div class="card-header d-flex justify-content-between align-items-center">

                                        <button class="btn btn-success btn-sm" @click="agregarInfoAdicional(idx_guia)">
                                            <i class="fas fa-plus"></i> Agregar
                                        </button>
                                    </div>

                                    <!-- BODY -->
                                    <div class="card-body p-2">

                                        <!-- LISTADO -->
                                        <div v-for="(info, idx_info_guia) in g.guias_info_adicionales"
                                            :key="idx_info_guia" class="dato-row">

                                            <div class="row align-items-center">

                                                <!-- TIPO DATO -->
                                                <div class="col-md-4 form-item">
                                                    <label>Dato</label>
                                                    <select class="form-control form-control-sm"
                                                        v-model="info.dato_adicional_id">
                                                        <option
                                                            v-for="(dato, i) in getOpcionesDatoAdicional(g.mp_tipos_id)"
                                                            :key="i" :value="dato.id">
                                                            {{ dato.nombre }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <!-- VALOR -->
                                                <div class="col-md-6 form-item">
                                                    <label>Valor</label>

                                                    <!-- TEXTO -->
                                                    <input v-if="getTipoDato(info.dato_adicional_id, idx_guia, 1)"
                                                        type="text" class="form-control form-control-sm"
                                                        v-model="info.valor_campo">

                                                    <!-- NUMERO -->
                                                    <input v-if="getTipoDato(info.dato_adicional_id, idx_guia, 2)"
                                                        type="number" class="form-control form-control-sm"
                                                        v-model="info.valor_campo">

                                                    <!-- ARCHIVO -->
                                                    <div v-if="getTipoDato(info.dato_adicional_id, idx_guia, 3)"
                                                        class="upload-mini">

                                                        <label class="upload-mini-input">
                                                            <i class="fas fa-upload"></i>
                                                            Subir archivo

                                                            <input type="file"
                                                                @change="subirArchivoAdicional($event, idx_guia, idx_info_guia)">
                                                        </label>

                                                        <button v-show="info.valor_campo != ''"
                                                            class="btn btn-outline-warning btn-sm mt-1"
                                                            @click="abrirArchivo(`guias/archivos_adicionales/${info.valor_campo}`)">
                                                            <i class="fas fa-file"></i> Ver
                                                        </button>

                                                    </div>

                                                </div>

                                                <!-- ELIMINAR -->
                                                <div class="col-md-2 text-center mt-3">
                                                    <button class="btn btn-danger btn-sm" style="border-radius: 100%;"
                                                        @click="quitarDatoAdicional(info, idx_guia, idx_info_guia)">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <!-- VACÍO -->
                                        <div v-if="g.guias_info_adicionales.length === 0"
                                            class="text-center text-muted py-3">
                                            No hay datos adicionales
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!--Seccion Guía-->









                    <!-- FORMULARIO PCC -->






                    <!-- Modal -->
                    <div class="modal fade" :id="`modal_g_historicas${g.numero_guia}_${g.documento_id_Etruck}`"
                        tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
                        v-if="guias_romana.length > 0">
                        <div class="modal-dialog modal-dialog-centered" role="document"
                            style="width: 95%; max-width: 1400px;">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">GUÍAS REEMPLAZADAS DE GUÍA N° {{
                                        g.numero_guia }}
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body" style="max-height:600px; overflow:auto;">
                                    <template v-for="guia_reemplazada in g.historicas">
                                        <div v-if="guia_reemplazada.habilitado_en != null"
                                            class="guia-reemplazada-container">
                                            <h6 @click="toggleDetalles(guia_reemplazada.numero_guia)"
                                                style="cursor: pointer;" class="guia-reemplazada-title mb-0">
                                                Guía reemplazada N° {{ guia_reemplazada.numero_guia }}
                                                <i :class="detallesVisibles[guia_reemplazada.numero_guia] ? 'fa fa-minus' : 'fa fa-plus'"
                                                    class="text-blue-500 text-lg"></i>
                                            </h6>
                                            <h6 class="guia-reemplazada-title guia-reemplazada-title-right">Fecha de
                                                reemplazo: {{ guia_reemplazada.habilitado_en | fecha_hora }}</h6>

                                            <!-- INFORMACIÓN DE GUÍA -->
                                            <div v-if="detallesVisibles[guia_reemplazada.numero_guia]">
                                                <div class="col-md-12">
                                                    <div class="table-responsive">
                                                        <table class="table align-items-center border">
                                                            <thead>
                                                                <tr class="thead-blue1">
                                                                    <th>N° GUÍA ORIGEN</th>
                                                                    <th>ARCHIVO GUÍA ORIGEN</th>
                                                                    <th>FECHA GUÍA</th>
                                                                    <th>EMPRESA</th>
                                                                    <th>SUCURSAL</th>
                                                                    <th>MATERIA PRIMA</th>
                                                                    <th>PESO INFORMADO</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <div
                                                                            style="display: flex; flex-direction: column;">
                                                                            {{ guia_reemplazada.numero_guia_origen }}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div
                                                                            style="display: flex; flex-direction: column;">
                                                                            <button style="max-width: 50px;"
                                                                                v-show="guia_reemplazada.url_guia_origen != null && guia_reemplazada.url_guia_origen != ''"
                                                                                class="btn btn-danger btn-sm"
                                                                                type="button"
                                                                                @click="abrirPdf(guia_reemplazada.url_guia_origen, 'guias/guias_origen')">
                                                                                ver
                                                                                <span class="btn-inner--icon"><i
                                                                                        class="fas fa-file-pdf"></i></span>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        {{ guia_reemplazada.fecha | fecha_hora }}
                                                                        <!-- <input type="datetime-local"
                                                                            class="form-control-sm" name="" id=""
                                                                            :value="guia_reemplazada.fecha"
                                                                            placeholder="dd-mm-aaaa hh:mm" readonly> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ getDatoDeListado(empresas,
                                                                            guia_reemplazada.empresas_id, 'id', 'nombre') }}
                                                                        <!-- <select class="form-control-sm full-width"
                                                                            v-model="guia_reemplazada.empresas_id"
                                                                            disabled>
                                                                            <option value="">-- Seleccionar --</option>
                                                                            <option v-for="(opc, index) in empresas"
                                                                                :key="index" :value="opc.id">
                                                                                {{ opc.nombre }}</option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ getDatoDeListado(dependencias,
                                                                            guia_reemplazada.dependencias_id, 'id',
                                                                            'nombre') }}
                                                                        <!-- <select class="form-control-sm full-width"
                                                                            v-model="guia_reemplazada.dependencias_id"
                                                                            disabled>
                                                                            <option value="">-- Seleccionar --</option>
                                                                            <option v-for="(opc, index) in dependencias"
                                                                                :key="index" :value="opc.id">
                                                                                {{ opc.nombre }}</option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ getDatoDeListado(mp_tipos,
                                                                            guia_reemplazada.mp_tipos_id, 'id', 'nombre') }}
                                                                        <!-- <select class="form-control-sm full-width"
                                                                            v-model="guia_reemplazada.mp_tipos_id"
                                                                            disabled>
                                                                            <option value="">-- Seleccionar --</option>
                                                                            <option v-for="(opc, index) in mp_tipos"
                                                                                :key="index" :value="opc.id">
                                                                                {{ opc.nombre }}</option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ guia_reemplazada.peso_informado |
                                                                            formatear_miles }}
                                                                        <!-- <input type="number"
                                                                            class="form-control-sm full-width"
                                                                            :value="guia_reemplazada.peso_informado"
                                                                            readonly> -->
                                                                    </td>
                                                                </tr>
                                                                <tr class="thead-blue1">
                                                                    <th>PESO RECIBIDO</th>
                                                                    <th>CANTIDAD BINS</th>
                                                                    <th>MUELLE</th>
                                                                    <th>BARCO</th>
                                                                    <th>RESTRICCIÓN</th>
                                                                    <th colspan="2">SUBIR GUÍA</th>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        {{ guia_reemplazada.peso_real | formatear_miles
                                                                        }}
                                                                        <!-- <input type="number"
                                                                            class="form-control-sm full-width"
                                                                            :value="guia_reemplazada.peso_real"
                                                                            readonly> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ guia_reemplazada.cantidad_bins |
                                                                            formatear_miles }}
                                                                        <!-- <input type="number"
                                                                            class="form-control-sm full-width"
                                                                            :value="guia_reemplazada.cantidad_bins"
                                                                            readonly> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ getDatoDeListado(muelles,
                                                                            guia_reemplazada.muelles_id, 'id', 'nombre') }}
                                                                        <!-- {{ muelles.find(muelle => muelle.id === guia_reemplazada.muelles_id).nombre }} -->
                                                                        <!-- <select class="form-control-sm full-width"
                                                                            :value="guia_reemplazada.muelles_id"
                                                                            disabled>
                                                                            <option v-for="(opc, index) in muelles"
                                                                                :key="index" :value="opc.id">{{
                                                                                    opc.nombre
                                                                                }}</option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ getDatoDeListado(barcos,
                                                                            guia_reemplazada.barcos_id, 'id', 'nombre') }}
                                                                        <!-- <select class="form-control-sm full-width"
                                                                            :value="guia_reemplazada.barcos_id"
                                                                            disabled>
                                                                            <option v-for="(opc, index) in barcos"
                                                                                :key="index" :value="opc.id">
                                                                                {{ opc.nombre }}</option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{
                                                                            getRestricciones(guia_reemplazada.restricciones_ids)
                                                                        }}
                                                                        <!-- <v-select multiple class=""
                                                                            :reduce="option => option.id"
                                                                            :value="guia_reemplazada.restricciones_ids"
                                                                            :options="restricciones" label="nombre"
                                                                            disabled>
                                                                            <template
                                                                                v-slot:no-options="{ search, searching }">
                                                                                <template v-if="searching">
                                                                                    No se encontraron resultados para
                                                                                    <em>{{
                                                                                        search }}</em>.
                                                                                </template>
                    <em style="opacity: 0.5;" v-else>Escriba
                        para filtrar...</em>
                    </template>
                    </v-select> -->
                                                                    </td>
                                                                    <td class="text-center" colspan="2">
                                                                        <div class="col-md-12">
                                                                            <div :class="`alert alert-sm alert-${guia_reemplazada.alert_clase} fade show`"
                                                                                role="alert"
                                                                                v-if="guia_reemplazada.alert">
                                                                                <span class="alert-icon"><i
                                                                                        :class="guia_reemplazada.alert_icono"></i></span>
                                                                                <span class="alert-text"><strong>{{
                                                                                    guia_reemplazada.alert_mensaje
                                                                                        }}!</strong> </span>
                                                                                <button type="button" class="close"
                                                                                    aria-label="Close"
                                                                                    @click="guia_reemplazada.alert = !guia_reemplazada.alert">
                                                                                    <span
                                                                                        aria-hidden="true">&times;</span>
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        <div class="col-12">
                                                                            <button
                                                                                v-show="guia_reemplazada.url_guia != null && guia_reemplazada.url_guia != ''"
                                                                                class="btn btn-danger btn-sm"
                                                                                type="button"
                                                                                @click="abrirPdf(guia_reemplazada.url_guia)">
                                                                                ver
                                                                                <span class="btn-inner--icon"><i
                                                                                        class="fas fa-file-pdf"></i></span>
                                                                            </button>
                                                                        </div>

                                                                        <div class="col-md-12">
                                                                            <small>NOTA: Puede editar la guía actual
                                                                                seleccionando un nuevo archivo</small>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </thead>
                                                        </table>
                                                    </div>
                                                </div>
                                                <!-- INFORMACIÓN DE GUÍA -->

                                                <!-- DISTRIBUCION DE MATERIA PRIMA -->
                                                <div class="col-12 mt-2">
                                                    <div class="table-responsive">
                                                        <table class="table align-items-center border">
                                                            <thead class="thead-skyblue4">
                                                                <tr>
                                                                    <th class="text-center" colspan="7">DISTRIBUCIÓN
                                                                        MATERIA
                                                                        PRIMA GUÍA N°{{
                                                                            guia_reemplazada.numero_guia }}</th>
                                                                </tr>
                                                                <tr>
                                                                    <th class="text-center" width="50">DESTINO</th>
                                                                    <th class="text-center">PRODUCTO RECIBIDO</th>
                                                                    <th class="text-center">MATERIA PRIMA</th>
                                                                    <th class="text-center">ESPECIE</th>
                                                                    <th class="text-center">CANTIDAD BINS</th>
                                                                    <th class="text-center">CANTIDAD (KG)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(distribucion, idx) in guia_reemplazada.distribuciones"
                                                                    :key="idx">
                                                                    <td>
                                                                        {{ getDatoDeListado(guia_distribucion_destinos,
                                                                            distribucion.distribucion_destinos_id, 'id',
                                                                            'nombre') }}
                                                                        <!-- <select class=""
                                                                            :value="distribucion.distribucion_destinos_id"
                                                                            disabled>
                                                                            <option
                                                                                v-for="(opc, index) in guia_distribucion_destinos"
                                                                                :key="index" :value="opc.id">
                                                                                {{ opc.nombre }}
                                                                            </option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ getDatoDeListado(productos_recibidos,
                                                                            guia_reemplazada.productos_recibidos_id,
                                                                            'id', 'nombre') }}
                                                                        <!-- <select class=""
                                                                            :value="guia_reemplazada.productos_recibidos_id"
                                                                            disabled>
                                                                            <option
                                                                                v-for="(opc, index) in productos_recibidos"
                                                                                :key="index" :value="opc.id">
                                                                                {{ opc.nombre }}
                                                                            </option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ getDatoDeListado(materias_primas,
                                                                            distribucion.mp_tipos_id, 'id', 'nombre') }}
                                                                        <!-- <select class=""
                                                                            :value="distribucion.mp_tipos_id" disabled>
                                                                            <option
                                                                                v-for="(opc, index) in materias_primas"
                                                                                :key="index" :value="opc.id">
                                                                                {{ opc.nombre }}
                                                                            </option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{
                                                                            getDatoDeListado(especies(distribucion.mp_tipos_id),
                                                                                distribucion.especies_id,
                                                                                'id', 'nombre') }}
                                                                        <!-- <select class=""
                                                                            :value="distribucion.especies_id" disabled>
                                                                            <option
                                                                                v-for="(opc, idx) in especies(distribucion.mp_tipos_id)"
                                                                                :key="idx" :value="opc.id">
                                                                                {{ opc.nombre }}
                                                                            </option>
                                                                        </select> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ distribucion.cantidad_bins | formatear_miles
                                                                        }}
                                                                        <!-- <input type="number"
                                                                            :value="distribucion.cantidad_bins"
                                                                            readonly> -->
                                                                    </td>
                                                                    <td>
                                                                        {{ distribucion.cantidad_bins | formatear_miles
                                                                        }}
                                                                        <!-- <input type="number"
                                                                            :value="distribucion.peso_real" readonly> -->
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <!-- DISTRIBUCION DE MATERIA PRIMA -->

                                                <!-- INFORMACION DE CENTRO Y JAULAS -->
                                                <div class="col-md-12 mt-2">
                                                    <table class="table table align-items-center table-bordered">
                                                        <thead class="thead-skyblue4">
                                                            <tr>
                                                                <th class="text-center" colspan="3">
                                                                    Informacion de Centros y Jaulas Guía N°{{
                                                                        guia_reemplazada.numero_guia }}
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th class="text-center">CODIGO SIEP CENTRO</th>
                                                                <th class="text-center">N° JAULAS</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(cen, idx_centro_jaula) in guia_reemplazada.guia_centro_jaulas"
                                                                :key="idx_centro_jaula">
                                                                <td>
                                                                    {{ cen.codigo_siep }}
                                                                    <!-- <input type="text" name="" id=""
                                                                        :value="cen.codigo_siep" readonly> -->
                                                                </td>
                                                                <td>
                                                                    {{ cen.nro_jaulas }}
                                                                    <!-- <input type="text" name="" id=""
                                                                        :value="cen.nro_jaulas"
                                                                        placeholder="Separado por comas" readonly> -->
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <!-- INFORMACION ADICIONAL DE GUIA -->
                                                <div class="col-md-12 mt-2">
                                                    <table class="table table align-items-center table-bordered">
                                                        <thead class="thead-skyblue4">
                                                            <th class="text-center">Dato Complementario Guía N°{{
                                                                guia_reemplazada.numero_guia }}</th>
                                                            <th class="text-center">Ingreso Dato</th>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(info, idx_info_guia) in guia_reemplazada.guias_info_adicionales"
                                                                :key="idx_info_guia">
                                                                <td>
                                                                    {{
                                                                        getDatoDeListado(getOpcionesDatoAdicional(guia_reemplazada.mp_tipos_id),
                                                                            info.dato_adicional_id, 'id', 'nombre') }}
                                                                    <!-- <select name="" id=""
                                                                        :value="info.dato_adicional_id" disabled>
                                                                        <option
                                                                            v-for="(dato, idx) in getOpcionesDatoAdicional(guia_reemplazada.mp_tipos_id)"
                                                                            :key="idx" :value="dato.id">
                                                                            {{ dato.nombre }}
                                                                        </option>
                                                                    </select> -->
                                                                </td>
                                                                <td>
                                                                    <!-- <input
                                                                        v-if="getTipoDato(info.dato_adicional_id, idx_guia, 1)"
                                                                        type="text" name="" id=""
                                                                        :value="info.valor_campo" readonly>
                                                                    <input
                                                                        v-if="getTipoDato(info.dato_adicional_id, idx_guia, 2)"
                                                                        type="number" name="" id=""
                                                                        :value="info.valor_campo" readonly> -->
                                                                    <span
                                                                        v-if="getTipoDato(info.dato_adicional_id, idx_guia, 1) || getTipoDato(info.dato_adicional_id, idx_guia, 2)">
                                                                        {{ info.valor_campo }}
                                                                    </span>
                                                                    <button
                                                                        v-show="getTipoDato(info.dato_adicional_id, idx_guia, 3) && info.valor_campo != ''"
                                                                        class="btn btn-icon btn-warning" type="button"
                                                                        @click="abrirArchivo(`guias/archivos_adicionales/${info.valor_campo}`)">
                                                                        ver
                                                                        <span class="btn-inner--icon"><i
                                                                                class="fas fa-file"></i></span>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <!-- INFORMACION ADICIONAL DE GUIA -->
                                            </div>

                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="col-md-12 mt-5">
                        <div style="height:10px;width:100%;background-color:#CFD8DC;border-radius:5px;"></div>
                    </div> -->
                </div>

                <!-- Modal -->
                <FormularioPccModal :formulario_pcc="formulario_pcc" :modal-id="`modal_pcc`"
                    :mp_tipos_id="this.ticket_romana.mp_tipos_id" modo="ticket"
                    @actualizado="onFormularioPccActualizado($event)" />



            </div>
        </div>
        <!-- <pre>
            MP_TIPO_DATO <br>
            {{mp_tipo_datos}}
        </pre> -->
        <!-- <pre>{{guias_romana}}</pre> -->
        <!-- <pre>{{ticket_romana}}</pre> -->

        <div v-if="showDialog" class="auto-dialog-overlay">

            <div class="auto-dialog-box">

                <!-- CERRAR -->
                <button class="auto-dialog-close" @click="closeDialog">
                    &times;
                </button>

                <!-- ICONO -->
                <div class="auto-dialog-icon">
                    <i :class="dialogIcon"></i>
                </div>

                <!-- MENSAJE -->
                <div class="auto-dialog-message">
                    {{ dialogMessage }}
                </div>

                <!-- PROGRESS -->
                <div class="auto-dialog-progress">
                    <div class="auto-dialog-progress-bar" :style="{ width: progress + '%' }">
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Swal from "sweetalert2";
import FormularioPccModal from '@/components/FormularioPCC/FormularioPccModal.vue';
import ToogleSwitch from '../../components/Inputs/ToogleSwitch.vue';

export default {
    components: {
        FormularioPccModal,
        ToogleSwitch
    },
    data: () => ({
        loading: false,
        nro_ticket: '',
        patente_camion: '',
        pesaje: {},
        folio_transbordador: null,
        conductor: null,
        detallesVisibles: {},
        documentos: [],
        nuevas_sucursales: [],
        tipo_dependencias: [],
        tipo_transportes: [],
        tipo_carrocerias: [],
        empresas_transbordador: [],
        comunas: [],
        ticket_romana: {},
        guias_romana: [],
        reemplazo_guia: false,
        empresas: [],
        dependencias: [],
        muelles: [],
        barcos: [],
        mp_tipos: [],
        tipos_info_adicional_guia: [],
        tipos_info_actuales: [],
        restricciones: [],
        guia_distribucion_destinos: [],
        //errores:[],
        //alert:false,
        file: '',
        //alert_2:false,
        //alert_2_mensaje:'',
        //alert_2_clase:'success',
        //alert_permisos:false,
        //mensajes_permisos:[],
        ingreso_porteria: null,
        viaje_camion: null,
        //errores:[],
        mp_tipo_datos: [],
        folios_disponibles: [],
        folio_1: null,
        folio_2: null,
        productos_recibidos: [],
        alert_mensaje: '',
        alert_class: '',
        alert_icono: '',
        alert_errores: [],
        alert_permisos: [],
        alert: false,
        showDialog: false,
        dialogMessage: '',
        dialogIcon: 'fas fa-check-circle',
        //duration: 5000, // ms
        progress: 100,
        interval: null,
        loadingMessage: '',
        sistemaPesaje: 'pesamatic',
        multiple_pcc: false,
        guia_actual: {},
        formulario_pcc_unico: null,
        folio_pcc_unico: null,
        formulario_pcc: {},
        idx_guia_pcc: null
    }),
    mounted() {
        this.actualizar_titulo('Recepción de Materia Prima')
        this.cargar_materias_primas();
    },
    methods: {

        abrirModalPCC(guia = null, idx = null) {
            this.idx_guia_pcc = idx
            this.limpiarFormularioPcc()

            if (this.multiple_pcc) {

                const form = this.guias_romana[0].formulario_pcc || {}

                this.formulario_pcc = {
                    id: form.id ?? null,
                    folio: form.folio ?? this.folio_pcc_unico,

                    cantidad_bins: this.guias_romana.reduce((total, guia) => {
                        return total + Number(guia.cantidad_bins || 0)
                    }, 0),

                    patente: this.ticket_romana.transporte.patente,

                    fecha: this.guias_romana[0].fecha,

                    numero_guia: this.guias_romana
                        .map(guia => guia.numero_guia)
                        .join(', '),

                    documentos_id_pesamatic: this.guias_romana
                        .map(g => g.documento_id_pesamatic),

                    subproducto: form.subproducto ?? null,
                    subproducto_listado_maestro: form.subproducto_listado_maestro ?? null,
                    subproducto_rest_mercado_dj: form.subproducto_rest_mercado_dj ?? null,
                    subproducto_guia_despacho: form.subproducto_guia_despacho ?? null,
                    subproducto_guia_despacho_accion_correctiva:
                        form.subproducto_guia_despacho_accion_correctiva ?? null,
                    subproducto_declaracion_jurada:
                        form.subproducto_declaracion_jurada ?? null,
                    subproducto_declaracion_jurada_accion_correctiva:
                        form.subproducto_declaracion_jurada_accion_correctiva ?? null,
                    subproducto_cumple_restriccion_horas_traslado:
                        form.subproducto_cumple_restriccion_horas_traslado ?? null,

                    mortalidad_guia_despacho:
                        form.mortalidad_guia_despacho ?? null,
                    mortalidad_guia_despacho_accion_correctiva:
                        form.mortalidad_guia_despacho_accion_correctiva ?? null,
                    mortalidad_declaracion_jurada:
                        form.mortalidad_declaracion_jurada ?? null,
                    mortalidad_declaracion_jurada_accion_correctiva:
                        form.mortalidad_declaracion_jurada_accion_correctiva ?? null,
                    mortalidad_cam:
                        form.mortalidad_cam ?? null,
                    mortalidad_cam_accion_correctiva:
                        form.mortalidad_cam_accion_correctiva ?? null,

                    observaciones: form.observaciones ?? null,

                    check_romanero: form.check_romanero ?? null,
                    romanero_id: form.romanero_id ?? null,

                    check_jefe_trazabilidad:
                        form.check_jefe_trazabilidad ?? null,
                    jefe_trazabilidad_id:
                        form.jefe_trazabilidad_id ?? null,

                    check_jefe_pac: form.check_jefe_pac ?? null,
                    jefe_pac_id: form.jefe_pac_id ?? null
                }
            }

            if (!this.multiple_pcc) {
                this.formulario_pcc = {
                    id: guia.formulario_pcc ? guia.formulario_pcc.id : null,
                    folio: guia.formulario_pcc ? guia.formulario_pcc.folio : guia.folio_pcc,
                    cantidad_bins: guia.cantidad_bins,
                    patente: this.ticket_romana.transporte.patente,
                    fecha: guia.fecha,
                    numero_guia: guia.numero_guia,
                    documentos_id_pesamatic: [guia.documento_id_pesamatic],
                    subproducto: guia.formulario_pcc
                        ? guia.formulario_pcc.subproducto
                        : null,

                    subproducto_listado_maestro: guia.formulario_pcc
                        ? guia.formulario_pcc.subproducto_listado_maestro
                        : null,

                    subproducto_rest_mercado_dj: guia.formulario_pcc
                        ? guia.formulario_pcc.subproducto_rest_mercado_dj
                        : null,

                    subproducto_guia_despacho: guia.formulario_pcc
                        ? guia.formulario_pcc.subproducto_guia_despacho
                        : null,

                    subproducto_guia_despacho_accion_correctiva: guia.formulario_pcc
                        ? guia.formulario_pcc.subproducto_guia_despacho_accion_correctiva
                        : null,

                    subproducto_declaracion_jurada: guia.formulario_pcc
                        ? guia.formulario_pcc.subproducto_declaracion_jurada
                        : null,

                    subproducto_declaracion_jurada_accion_correctiva: guia.formulario_pcc
                        ? guia.formulario_pcc.subproducto_declaracion_jurada_accion_correctiva
                        : null,

                    subproducto_cumple_restriccion_horas_traslado: guia.formulario_pcc
                        ? guia.formulario_pcc.subproducto_cumple_restriccion_horas_traslado
                        : null,

                    mortalidad_guia_despacho: guia.formulario_pcc
                        ? guia.formulario_pcc.mortalidad_guia_despacho
                        : null,

                    mortalidad_guia_despacho_accion_correctiva: guia.formulario_pcc
                        ? guia.formulario_pcc.mortalidad_guia_despacho_accion_correctiva
                        : null,

                    mortalidad_declaracion_jurada: guia.formulario_pcc
                        ? guia.formulario_pcc.mortalidad_declaracion_jurada
                        : null,

                    mortalidad_declaracion_jurada_accion_correctiva: guia.formulario_pcc
                        ? guia.formulario_pcc.mortalidad_declaracion_jurada_accion_correctiva
                        : null,

                    mortalidad_cam: guia.formulario_pcc
                        ? guia.formulario_pcc.mortalidad_cam
                        : null,

                    mortalidad_cam_accion_correctiva: guia.formulario_pcc
                        ? guia.formulario_pcc.mortalidad_cam_accion_correctiva
                        : null,

                    observaciones: guia.formulario_pcc
                        ? guia.formulario_pcc.observaciones
                        : null,

                    check_romanero: guia.formulario_pcc
                        ? guia.formulario_pcc.check_romanero
                        : null,

                    romanero_id: guia.formulario_pcc
                        ? guia.formulario_pcc.romanero_id
                        : null,

                    check_jefe_trazabilidad: guia.formulario_pcc
                        ? guia.formulario_pcc.check_jefe_trazabilidad
                        : null,

                    jefe_trazabilidad_id: guia.formulario_pcc
                        ? guia.formulario_pcc.jefe_trazabilidad_id
                        : null,

                    check_jefe_pac: guia.formulario_pcc
                        ? guia.formulario_pcc.check_jefe_pac
                        : null,

                    jefe_pac_id: guia.formulario_pcc
                        ? guia.formulario_pcc.jefe_pac_id
                        : null
                }
            }

            // Abrir modal
            $('#modal_pcc').modal('show')
        },

        limpiarFormularioPcc() {
            this.formulario_pcc = {
                id: null,
                folio: null,
                cantidad_bins: null,
                patente: null,
                fecha: null,
                numero_guia: null,
                documentos_id_pesamatic: null,

                subproducto: null,
                subproducto_listado_maestro: null,
                subproducto_rest_mercado_dj: null,
                subproducto_guia_despacho: null,
                subproducto_guia_despacho_accion_correctiva: null,
                subproducto_declaracion_jurada: null,
                subproducto_declaracion_jurada_accion_correctiva: null,
                subproducto_cumple_restriccion_horas_traslado: null,

                mortalidad_guia_despacho: null,
                mortalidad_guia_despacho_accion_correctiva: null,
                mortalidad_declaracion_jurada: null,
                mortalidad_declaracion_jurada_accion_correctiva: null,
                mortalidad_cam: null,
                mortalidad_cam_accion_correctiva: null,

                observaciones: null,

                check_romanero: null,
                romanero_id: null,

                check_jefe_trazabilidad: null,
                jefe_trazabilidad_id: null,

                check_jefe_pac: null,
                jefe_pac_id: null
            };
        },

        onFormularioPccActualizado(event) {
            if (this.multiple_pcc) {
                this.guias_romana.forEach((guia, index) => {
                    this.$set(
                        this.guias_romana[index],
                        'formulario_pcc',
                        { ...event }
                    );
                });
            } else {
                this.$set(this.guias_romana[this.idx_guia_pcc], 'formulario_pcc', { ...event });
            }
            // el componente ya mutó guia.formulario_pcc por referencia; no se requiere acción adicional.
        },
        async cargar_materias_primas() {
            await this.axios.get(`${this.api}/mps_tipo?limit=9999999`, this.cabeceras_json).then((res) => {
                this.materias_primas = res.data.data.data;
            }).catch((e) => {
                //console.log(e);
            })
            this.cargar_datos_adicionales();
        },
        toggleDetalles(numeroGuia) {
            this.$set(this.detallesVisibles, numeroGuia, !this.detallesVisibles[numeroGuia]);
        },
        isEmpty(obj) {
            return Object.keys(obj).length === 0;
        },
        async consultar_ticket() {
            this.loading = true;
            await this.cargar_materias_primas();
            //this.limpiar_formulario();
            if (this.nro_ticket) {
                await this.axios.get(`${this.api}/consultar_ticket_recepcion/${this.nro_ticket}/${this.sistemaPesaje}`, this.cabeceras_json).then((res) => {
                    //console.log('datos',res.data.data);
                    if (res.data.data.status == 200) {
                        console.log(res.data.data.guias_romana);
                        this.pesaje = res.data.data.pesaje;
                        this.documentos = res.data.data.documentos;
                        this.folio_pcc_unico = res.data.data.folio_pcc_unico;
                        this.multiple_pcc = res.data.data.multiple_pcc;
                        console.log('folio', this.folio_pcc_unico)
                        //this.nuevas_sucursales = res.data.data.nuevas_sucursales;
                        this.tipo_dependencias = res.data.data.tipo_dependencias;
                        this.comunas = res.data.data.comunas;
                        this.ticket_romana = res.data.data.ticket_romana;
                        this.ticket_romana.datos_modificados = res.data.data.ticket_romana_datos_modificados;
                        this.guias_romana = res.data.data.guias_romana;
                        this.reemplazo_guia = res.data.data.reemplazo_guia;
                        this.guias_romana.forEach((g, idx) => {
                            if (g.datos_modificados) {
                                if (Array.isArray(g.datos_modificados)) {
                                    g.tiene_datos_modificados = g.datos_modificados.length !== 0;
                                } else {
                                    g.tiene_datos_modificados = Object.keys(g.datos_modificados).length !== 0;
                                }
                            } else {
                                g.tiene_datos_modificados = false;
                            }

                            if (g.distribuciones && g.tiene_datos_modificados && g.distribuciones.length == 1 && g.datos_modificados.cantidad_bins) {
                                g.distribuciones[0].cantidad_bins = g.datos_modificados.cantidad_bins;
                            }

                            if (g.fecha) {
                                let userAgent = navigator.userAgent;
                                if (userAgent.match(/chrome|chromium|crios/i)) {
                                    //var timestamp = Date.parse(g.fecha);
                                    //console.log(new Date(timestamp).toISOString().slice(0,16));
                                    //this.$set(this.guias_romana[idx],'fecha',new Date(timestamp).toISOString().slice(0,16));
                                    //console.log(this.$moment(g.fecha).format("YYYY-MM-DDTHH:mm"));
                                    let fecha = this.$moment(g.fecha).format("YYYY-MM-DDTHH:mm");
                                    this.$set(this.guias_romana[idx], 'fecha', fecha);

                                } else if (userAgent.match(/firefox|fxios/i)) {
                                    this.$set(this.guias_romana[idx], 'fecha', this.$moment(g.fecha).format('YYYY-MM-DDTHH:mm'));
                                } else if (userAgent.match(/safari/i)) {

                                } else if (userAgent.match(/opr\//i)) {

                                } else if (userAgent.match(/edg/i)) {

                                } else {
                                    //no encontro navegador
                                }

                            }
                        });
                        this.empresas = res.data.data.empresas;
                        this.dependencias = res.data.data.dependencias;
                        this.muelles = res.data.data.muelles;
                        this.barcos = res.data.data.barcos;
                        this.mp_tipos = res.data.data.mp_tipos;
                        this.restricciones = res.data.data.restricciones;
                        this.conductor = res.data.data.conductor;
                        this.guia_distribucion_destinos = res.data.data.guia_distribucion_destinos;
                        this.ingreso_porteria = res.data.data.ingreso_porteria;
                        this.viaje_camion = res.data.data.viaje_camion;
                        this.tipo_transportes = res.data.data.tipo_transportes;
                        this.empresas_transbordador = res.data.data.empresas_transbordador;
                        this.folio_transbordador = res.data.data.folio_transbordador;
                        //this.alert_2_mensaje = res.data.data.mensaje;
                        //this.errores = res.data.data.errores;
                        this.folios_disponibles = res.data.data.folios_disponibles;
                        this.productos_recibidos = res.data.data.productos_recibidos;
                        this.tipo_carrocerias = res.data.data.tipo_carrocerias;
                        /* if(this.folio_transbordador){
                            this.folio_1 = {
                                talonarios_id:this.folio_transbordador.talonarios_1_id,
                                numero:this.folio_transbordador.folio_1
                            }

                            this.folio_2 = {
                                talonarios_id:this.folio_transbordador.talonarios_2_id,
                                numero:this.folio_transbordador.folio_2
                            }
                        } */
                        //alert(res.data.data.errores.length);
                        if (res.data.data.errores.length > 0) {
                            //alert('entra');
                            this.alert_mensaje = res.data.data.message;
                            this.alert_class = 'alert-2';
                            this.alert_errores = res.data.data.errores;
                            this.alert_permisos = [];
                            this.alert = true;


                            /* this.alert_2_clase = 'default';
                            this.alert_2 = true; */
                        }

                        this.guias_romana.forEach((g, idx) => {
                            this.$set(this.guias_romana[idx], 'alert', false);
                            this.$set(this.guias_romana[idx], 'alert_mensaje', '');
                            this.$set(this.guias_romana[idx], 'alert_clase', '');
                            this.$set(this.guias_romana[idx], 'alert_icono', '');
                        });
                    } else if (res.data.data.status == 400) {
                        this.limpiarDatos();
                        this.alert_mensaje = res.data.data.message;
                        this.alert_class = 'alert-1';
                        this.alert_errores = [];
                        this.alert_permisos = [];
                        this.alert = true;
                    } else if (res.data.data.status == 401) {

                        this.alert_mensaje = res.data.data.message;
                        this.alert_class = 'alert-2';
                        this.alert_errores = [];
                        this.alert_permisos = res.data.data.permisos;
                        this.alert = true;
                    }

                }).catch((e) => {
                    //console.log('error',e);
                });
            }
            this.loading = false;
        },

        limpiarDatos() {
            this.pesaje = {};
            this.documentos = [];
            //this.nuevas_sucursales = [];
            this.ticket_romana = {};
            this.guias_romana = [];
            this.conductor = null;
            this.guia_distribucion_destinos = [];
            this.ingreso_porteria = null;
            this.folio_transbordador = null;
            this.alert_2_mensaje = '';
            this.errores = [];
            this.alert_2 = false;
        },
        async crear_dependencia(sucursal) {
            //console.log('dependencia',sucursal);
            await this.axios.post(`${this.api}/dependencias`, sucursal, this.cabeceras_json).then((res) => {

                if (res.data.codigo == 200) {
                    this.consultar_ticket();
                    this.alert = false;
                    this.errores = [];
                } else {
                    //error de validacion
                    this.errores = res.data.data;
                    this.alert = true;
                }

            }).catch((e) => {
                //console.log('error',e);
            })
        },

        redondear(numero) {
            return Math.round(numero / 10) * 10;
        },

        subirGuia($event, nro_guia, index) {
            let ref = `file${nro_guia}`;
            //console.log('ref '+ref,$event);
            //this.file = this.$refs[ref].files[0];
            this.file = $event.target.files[0];
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('id', this.guias_romana[index].id);
            formData.append('codigo_ticket', this.ticket_romana.codigo_ticket);
            this.axios.post(`${this.api}/subir_archivo`, formData, this.cabeceras_archivo).then((res) => {
                this.$set(this.guias_romana[index], 'url_guia', res.data.filename);
                this.$set(this.guias_romana[index], 'alert_mensaje', res.data.mensaje);
                this.$set(this.guias_romana[index], 'alert_icono', 'ni ni-check-bold');
                this.$set(this.guias_romana[index], 'alert_clase', 'success');
                this.$set(this.guias_romana[index], 'alert', true);
            })
                .catch((e) => {
                    //console.log(e);
                    this.$set(this.guias_romana[index], 'alert_mensaje', 'No Se Ha podido Cargar la Guía');
                    this.$set(this.guias_romana[index], 'alert_icono', 'fas fa-ban');
                    this.$set(this.guias_romana[index], 'alert_clase', 'danger');
                    this.$set(this.guias_romana[index], 'alert', true);
                });
        },

        subirGuiaOrigen($event, nro_guia, index) {
            let ref = `file_origen_${nro_guia}`;
            //console.log('ref '+ref,$event);
            //this.file = this.$refs[ref].files[0];
            this.file = $event.target.files[0];
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('id', this.guias_romana[index].id);
            formData.append('codigo_ticket', this.ticket_romana.codigo_ticket);
            this.axios.post(`${this.api}/subir_archivo/guia_origen`, formData, this.cabeceras_archivo).then((res) => {
                this.$set(this.guias_romana[index], 'url_guia_origen', res.data.filename);
                this.$set(this.guias_romana[index], 'alert_mensaje', res.data.mensaje);
                this.$set(this.guias_romana[index], 'alert_icono', 'ni ni-check-bold');
                this.$set(this.guias_romana[index], 'alert_clase', 'success');
                this.$set(this.guias_romana[index], 'alert', true);
            })
                .catch((e) => {
                    //console.log(e);
                    this.$set(this.guias_romana[index], 'alert_mensaje', 'No Se Ha podido Cargar la Guía de Origen');
                    this.$set(this.guias_romana[index], 'alert_icono', 'fas fa-ban');
                    this.$set(this.guias_romana[index], 'alert_clase', 'danger');
                    this.$set(this.guias_romana[index], 'alert', true);
                });
        },

        subirArchivoAdicional($event, idx_guia, idx_info_guia) {

            //this.file = $event.target.files[0];
            let formData = new FormData();
            formData.append('file', $event.target.files[0]);
            formData.append('guias_id', this.guias_romana[idx_guia].id);
            this.axios.post(`${this.api}/subir_archivo_adicional`, formData, this.cabeceras_archivo).then((res) => {
                this.$set(this.guias_romana[idx_guia].guias_info_adicionales[idx_info_guia], 'valor_campo', res.data.filename);
            })
                .catch((e) => {
                    //console.log(e);
                });
        },

        async guardarTicket() {
            if (this.pesaje) {
                const result = await Swal.fire({
                    title: `¿Está seguro que desea guardar/reemplazar los datos del ticket?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#FF99AC",
                    confirmButtonText: "Sí, Confirmar",
                    cancelButtonText: "Cancelar"
                });

                if (!result.isConfirmed) {
                    return;
                }
                this.loading = true;
                this.loadingMessage = 'Guardando información, por favor espere...';
                /* this.folio_transbordador.folio_1 = this.folio_1.numero;
                this.folio_transbordador.talonarios_1_id = this.folio_1.talonarios_id;
                this.folio_transbordador.folio_2 = this.folio_2.numero;
                this.folio_transbordador.talonarios_2_id = this.folio_2.talonarios_id; */
                //console.log(this.folio_transbordador);
                //let incluir_folio = false;
                let folio_1 = this.folio_transbordador.folio_1;
                let folio_2 = this.folio_transbordador.folio_2;
                //if(folio_1 != "" && folio_2 != ""){

                let encontro_folio_1 = this.folios_disponibles.find(f => f.numero == folio_1);
                let encontro_folio_2 = this.folios_disponibles.find(f => f.numero == folio_2);
                console.log("folio 1", encontro_folio_1);
                console.log("folio 2", encontro_folio_2);

                if (encontro_folio_1 != undefined && encontro_folio_2 != undefined) {
                    this.folio_transbordador.talonarios_1_id = encontro_folio_1.talonarios_id;
                    this.folio_transbordador.talonarios_2_id = encontro_folio_2.talonarios_id;
                    //incluir_folio = true;
                }
                /* else{
                    //mostrar mensaje que no se encontraron los folios
                    this.alert_mensaje = 'Estimado usuario, La información de Folios no será ingresada por los siguientes motivos:';
                    this.alert_class = 'alert-1';
                    this.alert_errores = [];
                    if(encontro_folio_1 == undefined){
                        this.alert_errores.push(`El Folio N° ${folio_1} no fue encontrado dentro de los registros de folios disponibles`);
                    }
                    if(encontro_folio_1 == undefined){
                        this.alert_errores.push(`El Folio N° ${folio_2} no fue encontrado dentro de los registros de folios disponibles`);
                    }
                    this.alert_permisos = [];
                    this.alert = true;
                } */
                //}

                //console.log(folio_1,folio_2,encontro_folio_1,encontro_folio_2);

                let body = {
                    ticket_romana: this.ticket_romana,
                    guias_romana: this.guias_romana,
                    folio_transbordador: this.folio_transbordador,
                    viaje_camion: this.viaje_camion,
                    //folios_disponibles:this.folios_disponibles,
                    ingreso_vehiculo: this.ingreso_porteria,
                    reemplazo_guia: this.reemplazo_guia,
                };
                /* if(encontro_folio_1 == undefined && folio_1  != null){
                    body.encontro_folio_1 = false;
                }
                if(encontro_folio_2 == undefined && folio_2  != null){
                    body.encontro_folio_2 = false;
                } */
                /* if(incluir_folio){
                    body.folio_transbordador = this.folio_transbordador
                } */

                await this.axios.post(`${this.api}/ingresar_ticket`, body, this.cabeceras_json).then((res) => {
                    //console.log('ress',res.data);
                    if (res.data.success) {
                        this.openDialog(res.data.message, 'success', 5000);
                        this.limpiar_formulario();
                    } else {
                        this.alert_errores = res.data.errores;
                        this.alert_permisos = [];
                        this.alert_class = 'alert-2';
                        this.alert_mensaje = res.data.mensaje;
                        this.alert = true;
                    }

                }).catch((e) => {

                })
                this.loading = false;
            }
        },

        limpiar_formulario() {
            this.pesaje = {};
            this.ticket_romana = {};
            this.documentos = [];
            this.guias_romana = [];
            this.conductor = null;
            this.viaje_camion = null;
            this.errores = [];
            this.folio_transbordador = null;
            this.ingreso_porteria = null;
            this.folio_1 = null;
            this.folio_2 = null;
            this.nro_ticket = '';
            this.loadingMessage = 'Consultando Ticket'
        },

        cerrar_alert_2() {
            this.alert_2_mensaje = '';
            this.alert_2_clase = '';
            this.alert_2 = false;
        },

        abrirPdf(archivo, folder = 'guias') {
            let url = `${this.api_public}/${folder}/${archivo}`
            window.open(url, '_blank');
        },

        abrirArchivo(url) {
            window.open(`${this.api_public}/${url}`, '_blank');
        },

        especies(mps_id, guia_index, distribucion_index) {
            let array = [];

            if (mps_id != '' && mps_id != null) {
                let mp = this.mp_tipos.find(mp => mp.id == mps_id);
                array = mp.especies;
            }
            return array;
        },

        agregarDistribucion(guia_index) {
            this.guias_romana[guia_index].distribuciones.push({
                id: null,
                guias_id: this.guias_romana[guia_index].id,
                mp_tipos_id: this.guias_romana[guia_index].mp_tipos_id,
                especies_id: null,
                porcentaje: null,
                cantidad_bins: null,
                peso_real: null,
                destino: null,
                linea: null
            });
        },

        agregarInfoAdicional(guia_index) {
            this.guias_romana[guia_index].guias_info_adicionales.push({
                id: null,
                guias_id: this.guias_romana[guia_index].id,
                dato_adicional_id: null,
                valor_campo: ''
            });
        },

        agregarCentroJaula(guia_index) {
            this.guias_romana[guia_index].guia_centro_jaulas.push({
                id: null,
                guias_id: this.guias_romana[guia_index].id,
                codigo_siep: null,
                nro_jaulas: null
            });
        },

        async quitarDistribucion(distribucion, index_dist, index_guia) {
            if (distribucion.id != null) {
                //eliminar de bd
                await this.axios.delete(`${this.api}/guia_distribucion/${distribucion.id}`, this.cabeceras_json).then((res) => {
                    this.guias_romana[index_guia].distribuciones.splice(index_dist, 1);
                }).catch((e) => {
                    //console.log(e);
                });
            } else {
                this.guias_romana[index_guia].distribuciones.splice(index_dist, 1);
            }
        },

        async quitarCentroJaula(cen, index_guia, index_cen) {
            if (cen.id != null) {
                //eliminar de bd
                await this.axios.delete(`${this.api}/guia_centro_jaulas/${cen.id}`, this.cabeceras_json).then((res) => {
                    this.guias_romana[index_guia].guia_centro_jaulas.splice(index_cen, 1);
                }).catch((e) => {
                    //console.log(e);
                });
            } else {
                this.guias_romana[index_guia].guia_centro_jaulas.splice(index_cen, 1);
            }
        },

        async quitarDatoAdicional(dato, idx_guia, idx_info_guia) {
            if (dato.id != null) {
                //eliminar de bd
                await this.axios.delete(`${this.api}/guia_info_adicional/${dato.id}`, this.cabeceras_json).then((res) => {
                    let array = this.guias_romana[idx_guia].guias_info_adicionales;
                    array.splice(idx_info_guia, 1);
                    this.$set(this.guias_romana[idx_guia], 'guias_info_adicionales', array);
                    //this.guias_romana[idx_guia].guias_info_adicionales.splice(idx_info_guia,1);
                }).catch((e) => {
                    //console.log(e);
                });
            } else {
                let array = this.guias_romana[idx_guia].guias_info_adicionales;
                array.splice(idx_info_guia, 1);
                this.$set(this.guias_romana[idx_guia], 'guias_info_adicionales', array);
                //this.guias_romana[idx_guia].guias_info_adicionales.splice(idx_info_guia,1);
            }
        },

        async consultar_patente() {
            //console.log(this.patente_camion);
            await this.axios.get(`${this.api}/consultar_patente/${this.patente_camion}`, this.cabeceras_json).then((res) => {
                this.ingreso_porteria = res.data.data;
            }).catch((e) => {
                //console.log(e);
            })
        },

        async cargar_datos_adicionales() {
            await this.axios.get(`${this.api}/datos_adicionales_mp`, this.cabeceras_json).then((res) => {
                this.mp_tipo_datos = res.data.data;
            }).catch((e) => {
                //console.log(e);
            })
        },

        getOpcionesDatoAdicional(mp_tipos_id) {
            if (!mp_tipos_id) {
                return [];
            }
            return this.mp_tipo_datos.find(mp => mp.id == mp_tipos_id).datos_adicionales;
            ////console.log(this.tipos_info_adicional_guia.filter((d)=>d.mp_tipos_id == mp_tipos_id));
            ///return this.tipos_info_adicional_guia.filter((d)=>d.mp_tipos_id == mp_tipos_id);
        },

        getTipoInfoAdicional(mp_tipos_id) {
            return this.tipos_info_adicional_guia.filter((d) => d.mp_tipos_id == mp_tipos_id);
        },

        getTipoDato(dato_adicional_id, idx_guia, tipo) {
            ////console.log(dato_adicional_id,idx_guia,tipo);
            let mp_id = this.guias_romana[idx_guia].mp_tipos_id;
            if (!mp_id) {
                return false;
            }
            return this.mp_tipo_datos.find(mp => mp.id == mp_id).datos_adicionales.find(d => d.id == dato_adicional_id && d.tipo_dato == tipo) ? true : false;
            /*let tp = this.tipos_info_adicional_guia.find(tp => tp.id == id && tp.tipo_dato == tipo);
                return tp?true:false;
            /* if(tipo == 'texto'){
                let tp = this.tipos_info_adicional_guia.find(tp => tp.id == id && tp.tipo_dato == 1);//texto
                return tp?true:false;
                //console.log('tp',tp);
            } */

        },
        getDatoDeListado(listado, dato, atributo, atributoBuscado = null) {
            const registro = listado.find(item => item[atributo] == dato);
            if (registro && atributoBuscado) {
                if (registro[atributoBuscado]) return registro[atributoBuscado];
                else return null
            }
            return registro;
        },
        getRestricciones(restricciones_ids) {
            const restricciones = this.restricciones.filter(r => restricciones_ids.includes(r)).map(r => r.nombre).join(', ');
            return restricciones;
        },
        //NUEVO (MATERIA PRIMA EN TICKET)
        actualizarMateriaPrima() {
            this.guias_romana.forEach((g, idx) => {
                g.mp_tipos_id = this.ticket_romana.mp_tipos_id;
                g.distribuciones.forEach(d => {
                    d.mp_tipos_id = this.ticket_romana.mp_tipos_id;
                });
                if (this.ticket_romana.mp_tipos_id == 2 || this.ticket_romana.mp_tipos_id == 3) {
                    //si es ensilaje o mortalidad se agrega por defecto la restricción UE (id = 2)
                    let idx = g.restricciones_ids.findIndex(r => r == 2);
                    if (idx == -1) {
                        g.restricciones_ids.push(2);
                    }
                }
            });
        },

        actualizarDatoscomplementarios(guia_index) {
            let mp_id = this.guias_romana[guia_index].mp_tipos_id;
            let datos_adicionales = this.mp_tipo_datos.find(mp => mp.id == mp_id).datos_adicionales;
            let guias_info_adicionales_actuales = this.guias_romana[guia_index].guias_info_adicionales;
            let conservar = [];
            datos_adicionales.forEach(d => {
                let encuentra = this.guias_romana[guia_index].guias_info_adicionales.filter(r => r.dato_adicional_id == d.id);

                encuentra.forEach(d => {
                    conservar.push({
                        id: d.id,
                        valor_campo: d.valor_campo,
                        guias_id: d.guias_id,
                        dato_adicional_id: d.dato_adicional_id,
                        mp_tipos_id: mp_id,
                        numero_guia: this.guias_romana[guia_index].numero_guia
                    });
                });

            });
            this.$set(this.guias_romana[guia_index], 'guias_info_adicionales', []);

            //revisar datos adicionales que no esten
            datos_adicionales.forEach(da => {
                let esta = conservar.find(c => c.dato_adicional_id == da.id);
                if (!esta) {
                    conservar.push({
                        id: null,
                        valor_campo: '',
                        guias_id: this.guias_romana[guia_index].id,
                        dato_adicional_id: da.id,
                        mp_tipos_id: mp_id,
                        numero_guia: this.guias_romana[guia_index].numero_guia
                    });
                }
            });
            conservar.forEach(d => {

            });
            this.$set(this.guias_romana[guia_index], 'guias_info_adicionales', conservar);
            //console.log(this.guias_romana[guia_index].guias_info_adicionales);
        },

        calcularMultiplo10(numero) {
            if (numero == undefined || numero == null) {
                return false;
            }
            if (Number(numero) % 10 == 0) {
                return false;
            } else {
                return true;
            }
        },

        openDialog(message, type = 'success', duration = 3000) {
            this.dialogMessage = message
            this.duration = duration
            this.progress = 100
            this.showDialog = true

            // icono según tipo
            if (type === 'error') this.dialogIcon = 'fas fa-times-circle'
            else if (type === 'warning') this.dialogIcon = 'fas fa-exclamation-triangle'
            else this.dialogIcon = 'fas fa-check-circle'

            let step = 100 / (duration / 50)

            this.interval = setInterval(() => {
                this.progress -= step

                if (this.progress <= 0) {
                    this.closeDialog()
                }
            }, 50)
        },

        closeDialog() {
            this.showDialog = false
            clearInterval(this.interval)
        },
        ...mapActions(['actualizar_titulo'])
    },
    computed: {
        ...mapState(['api', 'api_public', 'cabeceras_json', 'cabeceras_archivo', 'usuario']),

        isEtruck: {
            get() {
                return this.sistemaPesaje === 'etruck';
            },
            set(value) {
                this.sistemaPesaje = value ? 'etruck' : 'pesamatic';
            }
        },

        peso_informado_total() {
            let peso = 0;
            this.documentos.forEach(guia => {
                peso += Number(guia.pesoInformado);
            });
            return peso;
        },

        peso_neto_corregido_romana() {
            if (this.ticket_romana) {
                return Number(this.ticket_romana.peso_vehiculo_bruto) - Number(this.ticket_romana.peso_vehiculo_tara);
            }
            return '';
        },

        mostrar_ticket_romana() {
            return true
            return this.nuevas_sucursales.length == 0 ? true : false;
        },

        mensaje() {
            let devolver = [];
            Object.keys(this.errores).forEach(key => {
                let array = this.errores[key];
                array.forEach(mensaje => {
                    devolver.push(mensaje);
                });
            });
            return devolver;
        },

        nombre_conductor() {
            if (this.conductor) {
                return `${this.conductor.nombres} ${this.conductor.apellidos}`
            }
            return '';
        },

    }
}
</script>
<style>
.alert-sm {
    padding: 0rem 0rem !important;
}

/* .thead-blue{
    background-color: #172b4d;
    color: #fff;
} */



.full-width {
    width: 100%;
}

.bg-light-green {
    background-color: #c5ebd8;
}

.btn:disabled {
    color: #27272b;
    border-color: #a5a7b3;
    background-color: #dbdbdb;
    cursor: default;
}

.border-right-white {
    border-right: #fff 1px solid;
}

.border-right-grey {
    border-right: 1px solid #e9ecef !important;
}

.element {
    height: 10em;
    width: 10em;
    margin: 0 auto;
    background-color: red;
    animation-name: stretch;
    animation-duration: 0.6s;
    animation-timing-function: ease-out;
    animation-delay: 0;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-fill-mode: none;
    animation-play-state: running;
}

@keyframes stretch {
    0% {
        transform: scale(.02);
        background-color: #440000;
        border-radius: 100%;
    }

    100% {
        transform: scale(.05);
        background-color: red;
        border-radius: 100%;
    }
}

/* .vs__search, .vs__search:focus {
z-index: 100000;
} */

.guia-card {
    border-radius: 12px;
    border: 1px solid #e3e6f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.section-title {
    font-size: 13px;
    font-weight: 800;
    color: #4e73df;
    margin-bottom: 10px;
    padding-left: 8px;
    border-left: 3px solid #4e73df;
}

.form-item {
    margin-bottom: 12px;
}

.form-item label {
    font-size: 12px;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 4px;
    display: block;
}

.form-control-sm {
    height: 32px;
    font-size: 13px;
}

.gap-2 {
    gap: 6px;
}

.distribucion-row {
    border: 1px solid #e3e6f0;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 8px;
    background: #fafafa;
}

.distribucion-row:hover {
    background: #f1f5ff;
}

.form-item label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 2px;
    display: block;
}

.form-control-sm {
    height: 30px;
    font-size: 12px;
}

.form-item small {
    font-size: 10px;
}

.upload-box {
    border: 1px dashed #cbd5e0;
    border-radius: 8px;
    padding: 10px;
    background: #f8fafc;
}

.upload-actions {
    margin-bottom: 6px;
}

.upload-input {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 6px;
    font-size: 12px;
    transition: all 0.2s;
}

.upload-input:hover {
    background: #eef2ff;
    border-color: #4e73df;
}

.upload-input i {
    font-size: 14px;
}

.upload-input input {
    display: none;
}

.centro-row {
    border: 1px solid #e3e6f0;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 8px;
    background: #fafafa;
}

.centro-row:hover {
    background: #f1f5ff;
}

.form-item label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 2px;
    display: block;
}

.form-control-sm {
    height: 30px;
    font-size: 12px;
}

.dato-row {
    border: 1px solid #e3e6f0;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 8px;
    background: #fafafa;
}

.dato-row:hover {
    background: #f1f5ff;
}

.form-item label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    margin-bottom: 2px;
    display: block;
}

.form-control-sm {
    height: 30px;
    font-size: 12px;
}

/* MINI UPLOAD */
.upload-mini-input {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 5px 8px;
    font-size: 12px;
}

.upload-mini-input:hover {
    background: #eef2ff;
    border-color: #4e73df;
}

.upload-mini-input input {
    display: none;
}

.trans-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 8px;
    border: 1px solid #e3e6f0;
    border-radius: 6px;
    background: #fafafa;
}

.trans-title {
    min-width: 70px;
    text-align: center;
    font-weight: bold;
    color: #fff;
    border-radius: 4px;
    padding: 4px;
    font-size: 12px;
}

/* reutiliza tu naranja */
.thead-orange {
    background-color: #f4a261;
}

/* campos */
.trans-field {
    display: flex;
    flex-direction: column;
    font-size: 12px;
}

.trans-field label {
    margin-bottom: 1px;
    color: #6c757d;
}

/* inputs mini */
.input-mini {
    height: 26px;
    font-size: 12px;
    padding: 2px 6px;
}

.vs__selected {
    font-size: 12px !important;
}

.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.dialog-box {
    width: 700px;
    max-width: 90%;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    animation: fadeIn 0.2s ease;
}

.dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
}

.dialog-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #dc3545;
}

.dialog-close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
}

.dialog-body {
    padding: 15px;
    max-height: 300px;
    overflow-y: auto;
}

.dialog-subtitle {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 5px;
}

.dialog-list {
    padding-left: 18px;
    font-size: 13px;
}

.dialog-list.error li {
    color: #dc3545;
}

.dialog-footer {
    padding: 10px 15px;
    border-top: 1px solid #eee;
    text-align: right;
}

.auto-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(3px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.auto-dialog-box {
    width: 320px;
    background: #fff;
    border-radius: 12px;
    padding: 20px 15px 15px;
    text-align: center;
    position: relative;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    animation: fadeInScale 0.2s ease;
}

.auto-dialog-icon {
    font-size: 40px;
    margin-bottom: 10px;
    color: #7cb518;
}

.auto-dialog-message {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 15px;
}

.auto-dialog-close {
    position: absolute;
    top: 8px;
    right: 10px;
    border: none;
    background: none;
    font-size: 18px;
    cursor: pointer;
}

.auto-dialog-progress {
    height: 4px;
    background: #e5e7eb;
    border-radius: 4px;
    overflow: hidden;
}

.auto-dialog-progress-bar {
    height: 100%;
    background: #7cb518;
    transition: width 0.05s linear;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

/* Caja central */
.loading-card {
    background: #ffffff;
    padding: 25px 30px;
    border-radius: 12px;
    text-align: center;
    min-width: 220px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    animation: fadeInScale 0.2s ease;
}

/* Spinner más moderno */
.loading-spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #e5e7eb;
    border-top: 5px solid #7cb518;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: 0 auto 12px;
}

/* Texto */
.loading-message {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
}

.pesaje-switch {
    background: linear-gradient(90deg, #0d1f45, #1e3a8a);
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 8px 12px;
    min-width: 130px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.pesaje-switch .label {
    font-size: 11px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.pesaje-switch .value {
    font-size: 13px;
    font-weight: 700;
    color: #fff;
}

/* SWITCH */
.switch {
    position: relative;
    display: inline-block;
    width: 42px;
    height: 22px;
}

.switch input {
    display: none;
}

.slider {
    position: absolute;
    cursor: pointer;
    background-color: #cbd5e1;
    border-radius: 999px;
    inset: 0;
    transition: 0.3s;
}

.slider:before {
    content: "";
    position: absolute;
    height: 16px;
    width: 16px;
    left: 3px;
    top: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.3s;
}

input:checked+.slider {
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
}

input:checked+.slider:before {
    transform: translateX(20px);
}

.viaje-row {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 12px 16px;
    border-radius: 12px;
    background: linear-gradient(90deg, #0d1f45, #1e3a8a);
    color: white;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
    overflow-x: auto;
}

/* cada bloque */
.cell {
    display: flex;
    flex-direction: column;
    min-width: 110px;
}

/* etiquetas */
.cell span {
    font-size: 10px;
    opacity: 0.7;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* valores */
.cell strong {
    font-size: 14px;
    font-weight: 600;
}

/* ID destacado */
.cell.id strong {
    font-size: 18px;
    color: #38bdf8;
}

/* patente estilo badge */
.patente strong {
    background: #facc15;
    color: #000;
    padding: 3px 8px;
    border-radius: 6px;
    width: fit-content;
}

/* cantidad guías */
.highlight {
    color: #22c55e;
    font-size: 16px;
}

/* lista guías */
.guias strong {
    font-size: 12px;
    opacity: 0.9;
    white-space: normal;
    /* 👈 permite saltos */
    word-break: break-word;
    /* 👈 rompe palabras largas */
}

/* Animaciones */
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* animación */
@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>

<style scoped>
.spinner-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    display: inline-block;
    width: 70px;
    height: 70px;
    border: 8px solid #fff;
    border-radius: 50%;
    border-top-color: #5e72e4;
    animation: rotate 1s linear infinite;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.guia-reemplazada-container {
    position: relative;
    border: 1px solid #e9ecef;
    border-radius: 1rem;
    padding: 1.2rem 0.4rem;
    margin-bottom: 1rem;
}

.guia-reemplazada-title {
    position: absolute;
    top: 0;
    left: 2rem;
    transform: translateY(-50%);
    font-size: 1rem;
    padding: 0 0.5rem;
    background-color: white;
}

.guia-reemplazada-title-right {
    left: auto;
    right: 2em;
}

/* Tooltip container */
.custom-tooltip {
    position: relative;
    display: inline;
    min-width: 1.1rem;
    text-align: center;
    border-radius: 100%;
}

/* Tooltip text */
.custom-tooltip .custom-tooltiptext {
    visibility: hidden;
    width: max-content;
    background-color: rgb(41, 50, 65);
    color: #fff;
    padding: 5px 0;
    border-radius: 6px;

    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 3;
    max-height: 15rem;
    overflow: auto;
}

/* Show the tooltip text when you mouse over the tooltip container */
.custom-tooltip:hover .custom-tooltiptext {
    visibility: visible;
}

.custom-tooltip .custom-tooltiptext {
    top: -5px;
    left: 105%;
    text-align: left;
    padding: 6px 6px 0;
}

.peso-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
}

.peso-wrapper .arrow {
    color: #64748b;
    /* gris elegante */
}

.peso-wrapper .nuevo {
    font-weight: 600;
    color: #38b000;
    /* verde/teal moderno */
}

.peso-wrapper .warning {
    color: #f59e0b;
    /* amarillo warning */
    font-size: 12px;
}

.texto-ayuda {
    display: block;
    color: #64748b;
    font-size: 12px;
    margin-top: 2px;
}
</style>